/**
 * App variants
 */

export const STORE_APP_VARIANT = 'STORE_APP_VARIANT'

/**
 * User
 */
export const SAVE_USER = 'SAVE_USER'
export const REFRESH_USER = 'REFRESH_USER'
/**
 * Listing
 */
export const STORE_LISTING = 'STORE_LISTING'
/**
 * Property
 */
export const STORE_RECENT_SAVED_PROPERTIES = 'STORE_RECENT_SAVED_PROPERTIES'
export const STORE_SAVED_PROPERTY_IDENTIFIERS =
  'STORE_SAVED_PROPERTY_IDENTIFIERS'
export const APPEND_SAVED_PROPERTY = 'APPEND_SAVED_PROPERTY'
export const SPLICE_SAVED_PROPERTY = 'SPLICE_SAVED_PROPERTY'
/**
 * Modals
 */
export const TOGGLE_CONTACT_MODAL = 'TOGGLE_CONTACT_MODAL'

/**
 * BannerMessage
 */
export const BANNER_MESSAGE_SHOW = 'BANNER_MESSAGE_SHOW'
export const BANNER_MESSAGE_CLOSE = 'BANNER_MESSAGE_CLOSE'

/**
 * Property Analytics
 */
export const SAVE_PROPERTY_ANALYTICS = 'SAVE_PROPERTY_ANALYTICS'
export const SAVE_IS_PROPERTY_REPORT_AVAILABLE =
  'SAVE_IS_PROPERTY_REPORT_AVAILABLE'
export const SAVE_REALTY_TRACK_REPORT = 'SAVE_REALTY_TRACK_REPORT'
export const UPDATE_SIMILAR_PROPERTIES_SAVE_STATUS =
  'UPDATE_SIMILAR_PROPERTIES_SAVE_STATUS'
export const DISPLAY_SMS_OPTIN_MODAL = 'DISPLAY_SMS_OPTIN_MODAL'

/**
 * Feature Flags
 */
export const STORE_FEATURE_FLAGS = 'STORE_FEATURE_FLAGS'

/**
 * Suggested Offer
 */

export const STORE_SUGGESTED_OFFER = 'STORE_SUGGESTED_OFFER'
